import * as types from '../mutation-types'

const state = {
  isLoading: true
}

const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

const actions = {
  LOGIN ({ commit }, value) {
    commit(types.LOGIN, value)
  },
  LOGOUT ({ commit }) {
    commit(types.LOGOUT)
  },
  ADD_MENU_ITEM ({ commit }, value) {
      commit(types.ADD_MENU_ITEM, value)
  },
  REMOVE_MENUS ({ commit }) {
    commit(types.REMOVE_MENUS)
  },
  USER_INFORMATION ({ commit }, value) {
      commit(types.USER_INFORMATION, value)
  },
  REMOVE_USER_INFORMATION ({ commit }) {
    commit(types.REMOVE_USER_INFORMATION)
  }
}

export default {
  state,
  mutations,
  actions
}
